import api from './api';

export interface PipelineStage {
  stage: string;
  label: string;
  sampleCount: number;
  lotCount: number;
  avgAgeDays: number;
  maxAgeDays: number;
}

export interface ClientSummary {
  clientId: string;
  clientName: string;
  activeLots: number;
  activeSamples: number;
  oldestAgeDays: number;
  critical: number;
  warning: number;
  ok: number;
}

export interface TransferSummary {
  fromLocationCode: string;
  transferCount: number;
  sampleCount: number;
  avgTransitDays: number;
  oldestTransitDays: number;
}

export interface CriticalLot {
  batchNumber: string;
  clientName: string;
  sampleCount: number;
  status: string;
  statusRaw: string;
  ageDays: number;
  received: string;
  lastModified: string;
  urgency: 'critical' | 'warning' | 'ok';
}

export interface AdminMonitoringData {
  pipeline: PipelineStage[];
  urgency: {
    critical: { lots: number; samples: number };
    warning: { lots: number; samples: number };
    ok: { lots: number; samples: number };
  };
  clients: ClientSummary[];
  transfers: TransferSummary[];
  bottlenecks: PipelineStage[];
  criticalLots: CriticalLot[];
  generatedAt: string;
}

export interface LotsFilter {
  urgency?: 'critical' | 'warning' | 'ok';
  clientId?: string;
  page?: number;
  limit?: number;
}

export interface LotsPageResult {
  lots: CriticalLot[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export async function fetchAdminMonitoring(): Promise<AdminMonitoringData> {
  return api.get<AdminMonitoringData>('/samples/admin-monitoring');
}

export async function fetchAdminLots(filter: LotsFilter = {}): Promise<LotsPageResult> {
  const params = new URLSearchParams();
  if (filter.urgency) params.set('urgency', filter.urgency);
  if (filter.clientId) params.set('clientId', filter.clientId);
  if (filter.page) params.set('page', String(filter.page));
  if (filter.limit) params.set('limit', String(filter.limit));
  const qs = params.toString();
  return api.get<LotsPageResult>(`/samples/admin-monitoring/lots${qs ? `?${qs}` : ''}`);
}
